import { render, staticRenderFns } from "./paymentsStudentTable.vue?vue&type=template&id=78b36e66&"
import script from "./paymentsStudentTable.vue?vue&type=script&lang=js&"
export * from "./paymentsStudentTable.vue?vue&type=script&lang=js&"
import style0 from "./paymentsStudentTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports